import React from 'react';
import { useTranslations } from 'next-intl';
import { useFullscreenOverlay } from './FullscreenOverlayContext';
import {
  header,
  headerColumn1,
  headerColumn2,
  headerColumn3,
  headerColumns,
  headerSubtitle,
  headerTitle,
  mediaCloseButtonInline,
  overlayBackButton,
} from './fullscreenOverlay.styles';
import { ChevronLeft } from 'lucide-react';
import { CloseButton } from '@zillow/constellation-10';
import { LucideIcon } from '@/src/components/LucideIcon';
import type { FullscreenOverlayHeaderProps } from './types';

export const FullscreenOverlayHeader = ({
  title,
  subtitle,
  actions,
  showCloseButton = true,
  closeLabel,
  layout = 'sticky',
  variant = 'standard',
  scrollContainerRef,
}: FullscreenOverlayHeaderProps) => {
  const t = useTranslations('common');
  const { close } = useFullscreenOverlay();

  void scrollContainerRef;

  const handleCloseClick = () => {
    close();
  };

  if (variant === 'media' && layout === 'floating') {
    if (actions) {
      return (
        <header className={header({ layout: 'floating', variant: 'media' })}>
          <div className={headerColumns}>
            <div className={headerColumn1}>
              <CloseButton onClick={handleCloseClick} title={t('closeOverlay')} className={mediaCloseButtonInline} />
            </div>
            <div className={headerColumn2} />
            <div className={headerColumn3}>{actions}</div>
          </div>
        </header>
      );
    }
    return <CloseButton onClick={handleCloseClick} title={t('closeOverlay')} />;
  }

  return (
    <header className={header({ layout, variant })}>
      <div className={headerColumns}>
        <div className={headerColumn1}>
          {showCloseButton &&
            (closeLabel ? (
              <button className={overlayBackButton} onClick={handleCloseClick} aria-label={closeLabel}>
                <LucideIcon icon={ChevronLeft} size="sm" />
                <span>{closeLabel}</span>
              </button>
            ) : (
              <CloseButton onClick={handleCloseClick} title={t('closeOverlay')} />
            ))}
        </div>

        <div className={headerColumn2}>
          {title && (
            <h2 id="overlay-title" className={headerTitle}>
              {title}
            </h2>
          )}
          {subtitle && <p className={headerSubtitle}>{subtitle}</p>}
        </div>

        <div className={headerColumn3}>{actions}</div>
      </div>
    </header>
  );
};
